<template>
  <v-container grid-list-md>
    <v-layout row wrap align-center justify-center fill-height>
      <v-flex xs12 sm8 lg4 md5>
        <v-card class="login-card">
          <v-card-title>
            <span class="headline login-title">Login to Omics-based Drug Discovery Platform</span>
          </v-card-title>

          <v-spacer />

          <v-card-text>
            <v-snackbar
              v-model="registrationSuccess"
              type="success"
              color="primary"
              dismissible
              top right
              @input="clearRegistrationSuccess"
            >
              ユーザー登録が完了しました。ログインしてください。
            </v-snackbar>

            <v-layout
              v-if="loading"
              row
              fill-height
              justify-center
              align-center
            >
              <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
              />
            </v-layout>
            <v-form
              v-else
              ref="form"
              v-model="valid"
              @keyup.native.enter="login"
            >
              <v-container>
                <v-text-field
                  v-model="credentials.username"
                  label="ユーザ名"
                  :rules="[v => !!v || 'ユーザ名は必須です',
                           v => isAlphaNumeric(v) || 'ユーザ名は英数字のみ使用できます']"
                  required
                />
                <v-text-field
                  v-model="credentials.password"
                  type="password"
                  label="パスワード"
                  :rules="[v => !!v || 'パスワードは必須です',
                           v => isAlphaNumeric(v) || 'パスワードは英数字のみ使用できます']"
                  required
                />
              </v-container>
              <div class="d-flex justify-space-between align-center">
                <v-btn
                  class="pink white--text"
                  :disabled="!valid"
                  @click="login"
                >
                  Login
                </v-btn>
                <a
                  class="red--text"
                  href="/registration"
                >
                  Register as a new user
                </a>
              </div>
              <div class="d-flex justify-end mt-2">
                <a
                  href="/RegistrationManual.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Registration Manual
                </a>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Swal from 'sweetalert2';
import router from '../router';

export default {
  name: 'Auth',
  data: () => ({
    credentials: {},
    valid: false,
    loading: false
  }),
  computed: {
    registrationSuccess() {
      return this.$store.getters['registration/registrationSuccess'];
    }
  },
  methods: {
    isAlphaNumeric(text) {
      const regex = /^[a-zA-Z0-9]+$/;
      return text && regex.test(text);
    },
    clearRegistrationSuccess() {
      this.$store.commit('registration/clearRegistrationSuccess');
    },
    login() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const self = this;
        this.api.authenticateUser(this.credentials, function(res) {
          self.$session.start();
          self.$session.set('token', res.data.token);
          self.$session.set('tokenInitTime', Date.now());
          router.push('/');
        }, function() {
          self.loading = false;
          Swal.fire({
            icon: 'error',
            text: 'ユーザー名もしくはパスワード、または両方が間違っています',
            showConfirmButton: true,
            showCloseButton: false
          });
        });
      }
    }
  }
};
</script>

<style scoped>
.login-title {
  word-break: normal;
  overflow-wrap: break-word;
  hyphens: auto;
}
</style>
